// ink-component
import React, { useContext } from 'react';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavSectionLabel } from './styles';

export type SideNavSectionLabelProps = {
  /** Section label text */
  text: string;
  /** Marks the element with a given ID to make it easier to select it on tests */
  'data-testid'?: string | number;
};

/**
 * @purpose Section label
 * @group SideNav
 * @categories navigation
 */
const SideNavSectionLabel = ({ text, 'data-testid': dataTestId }: SideNavSectionLabelProps) => {
  const { isClosed } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});

  return (
    <StyledSideNavSectionLabel isClosed={isClosed} {...globalProps} data-testid={dataTestId}>
      {!isClosed && text}
    </StyledSideNavSectionLabel>
  );
};

SideNavSectionLabel.displayName = 'SideNav.SectionLabel';

export default SideNavSectionLabel;
